import { useMemo } from 'react';
import api from '../api';
import useToast from './useToast';

export default function useAPI() {
  const addToast = useToast();

  const handleResponse = (response) => {
    if (!response || response.error) { addToast.error(response?.error?.message ?? 'Не удалось совершить операцию'); }
    return response;
  };
  const result = useMemo(() => ({
    get:  async (...args) => handleResponse(await api.get(...args)),
    post: async (...args) => handleResponse(await api.post(...args)),
    delWithPromise: async (...args) => handleResponse(await api.delWithPromise(...args)),
    postFormData: async (...args) => handleResponse(await api.postFormData(...args)),
    postProjAttachments: async (...args) => handleResponse(await api.postProjAttachments(...args)),
    postFileFixed: async (...args) => handleResponse(await api.postFileFixed(...args)),
    postProjAttachments: async (...args) => handleResponse(await api.postProjAttachments(...args)),
    putResponseText: async (...args) => handleResponse(await api.putResponseText(...args)),
    del: async (...args) => handleResponse(await api.del(...args)),
    download: async (...args) => handleResponse(await api.download(...args)),
    postFiles: async (...args) => handleResponse(await api.postFiles(...args)),
    put: async (...args) => handleResponse(await api.put(...args))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }), []);

  return result;
}
